<form *ngIf="entry && entry.fg" [formGroup]="entry.fg">

  <digires-state-indicator [readOnly]="!!entry?.getUser() && readOnly?.isReadOnly()"
                           [readOnlyReason]="readOnly?.getReadOnlyTooltip()"
  ></digires-state-indicator>

  <digires-team-member-bubble [userId]="entry?.getUser()?.id"
                               [roleId]="entry?.getRole()?.id"
  ></digires-team-member-bubble>

  <mat-form-field class="team-member-entry-user">
    <mat-label>{{getAccountNamePlaceholder()}}</mat-label>
    <label>
      <input matInput type="text"
             formControlName="user"
             [required]="entry.mandatory"
             [readonly]="readOnly?.isReadOnly()"
             [ngClass]="{'changed': entry.fg.dirty}"
             [matAutocomplete]='autocompleteUser'
             (input)="onFilterUsers($event)">
    </label>

    <mat-autocomplete #autocompleteUser="matAutocomplete"
                      [displayWith]="getUserName.bind(this)"
                      (optionSelected)="onUserSelected($event.option.value)">
      <mat-option *ngFor="let value of filteredUsers" [value]="value">
        {{value.fullName}}
      </mat-option>
    </mat-autocomplete>

    <mat-error>{{getUserErrorMessage()}}</mat-error>
  </mat-form-field>

  <mat-icon class="tooltip-icon"
            [class.visibility-hidden]="!entry.getTooltip()"
            matTooltipPosition="above"
            matTooltip="{{entry.getTooltip()}}"
            svgIcon="tooltip"
  ></mat-icon>

  <mat-form-field *ngIf="entry.isRoleChangePossible()"
                  class="team-member-entry-user"
                  matTooltipPosition="above"
                  [matTooltip]="entry.getRoleName()">
    <mat-label>Role within Team</mat-label>
    <label>
      <input matInput type="text"
             formControlName="role"
             required
             [readonly]="readOnly?.isReadOnly()"
             [ngClass]="{'changed': entry.fg.dirty}"
             [matAutocomplete]='autocompleteRole'
             (input)="onFilterRoles($event)">
    </label>

    <mat-autocomplete #autocompleteRole="matAutocomplete"
                      [displayWith]="getRoleNameForRole.bind(this)"
                      (optionSelected)="onRoleSelected($event.option.value)">
      <mat-option *ngFor="let value of filteredRoles" [value]="value" [matTooltip]="value.name">
        <mat-icon *ngIf="isRoleMandatory(value)">star</mat-icon>
        <mat-icon *ngIf="isConstructionRoleMandatory(value)">navigation</mat-icon>
        {{value.name}}
      </mat-option>
    </mat-autocomplete>

    <mat-error>Please select a role for this team member</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="showDepartment && entry.getUserData('department')"
                  class="team-member-entry-department"
                  matTooltipPosition="above"
                  [matTooltip]="entry.getUserData('department')">
    <mat-label>Department</mat-label>
    <label>
      <input matInput type="text"
             readonly
             [value]="entry.getUserData('department')">
    </label>
  </mat-form-field>

  <button *ngIf="isRoleDeletable() && showCheckbox"
          mat-icon-button type="button"
          [disabled]="readOnly?.isReadOnly()"
          (click)="onDelete.emit()">
    <mat-icon>delete</mat-icon>
  </button>

  <mat-icon *ngIf="isDuplicateIconVisible()" matTooltip="Role is duplicated.">
    content_copy
  </mat-icon>

  <digires-checkbox *ngIf="isDeputy() && showCheckbox"
    [formGroup]="entry.fg"
    formCtrlName="enableEmails"
    [disabled]="readOnly?.isReadOnly()"
    tooltip="When unchecked the Deputy Manager will not receive the usual email notifications for
    changes done to the project."
  >
    Notifications
  </digires-checkbox>

</form>
